<template>
  <div class="contact-frame">
    <a class="anchor" id="dotJqywh"></a>
    <div class="home-title-bt">
      <div class="home-t-bg">Corporate Culture</div>
      <p>企业文化</p>
    </div>
    <div class="culture-main">
      <div class="culture-bg"></div>
      <div class="culture-data">
        <p
          class="wow fadeInUp animated"
          data-wow-duration="1s"
          data-wow-delay=".2s"
        >
          <span>企业使命：</span
          ><span class="text-w">为国分忧 为民解愁</span>
        </p>

        <p
          class="wow fadeInUp animated"
          data-wow-duration="1s"
          data-wow-delay=".3s"
        >
          <span>企业愿景：</span><span class="text-w">加速中国特殊资产行业智能化发展</span>
        </p>
        <p
                class="wow fadeInUp animated"
                data-wow-duration="1s"
                data-wow-delay=".4s"
        >
          <span style="white-space:nowrap">企业价值观：</span
          ><span class="text-w">实干 利他 </span>
        </p>
        <p
          class="wow fadeInUp animated"
          data-wow-duration="1s"
          data-wow-delay=".4s"
        >
          <span>企业宗旨：</span
          ><span class="text-w"
            >技术驱动，提升服务质效；融合处置，助力保值增值</span>
        </p>
        <p
                class="wow fadeInUp animated"
                data-wow-duration="1s"
                data-wow-delay=".4s"
        >
          <span>产品理念：</span
          ><span class="text-w">立足市场，持续升级；精准智能，高效合规</span>
        </p>
        <p
          class="wow fadeInUp animated"
          data-wow-duration="1s"
          data-wow-delay=".5s"
        >
          <span>经营理念：</span
          ><span class="text-w"
            >没有不良的资产，只有错配的资源，打造特殊资产行业的朋友圈和生态圈，共创共赢</span
          >
        </p>
        <p
          class="wow fadeInUp animated"
          data-wow-duration="1s"
          data-wow-delay=".6s"
        >
          <span>经营底线：</span
          ><span class="text-w">不募集资金、不投资资产</span>
        </p>
      </div>
      <div
        class="culture-img wow fadeInUp animated"
        data-wow-duration="1s"
        data-wow-delay=".2s"
      >
        <img src="../../../assets/images/join/join-wh.jpg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "culture",
  mounted() {
    this.$nextTick(() => {
      new this.$wow.WOW().init();
    });
  },
};
</script>

<style scoped lang="scss">
.contact-frame {
  position: relative;
  .anchor {
    position: absolute;
    opacity: 0;
    top: -200px;
  }
  .culture-main {
    padding: 130px 0 0 65px;
    height: 551px;
    position: relative;
    .culture-bg {
      position: absolute;
      width: 158px;
      height: 332px;
      background: #ebf1ff;
      top: 113px;
      left: 50px;
    }
    .culture-data {
      position: relative;
      font-size: 18px;
      color: #333333;
      width: 600px;
      line-height: 30px;
      font-family: "SourceHanSansCN-Regular";
      p {
        overflow: hidden;
        padding-bottom: 10px;
        display: flex;
        span:first-child {
          display: flex;
          justify-content: flex-end;
          margin-right: 24px;
          font-weight: bold;
          width: 130px;
        }
        .text-w {
          flex: 1;
          font-weight: normal;
        }
      }
    }
    .culture-img {
      position: absolute;
      width: 511px;
      height: 349px;
      overflow: hidden;
      right: -26px;
      top: 95px;
      img {
        width: 511px;
        height: 349px;
        display: block;
      }
    }
  }
}
</style>
